import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
export interface QuoteElement {
  value: string;
  label: string;
}
@Component({
  selector: 'app-quote-summary',
  templateUrl: './quote-summary.component.html',
  styleUrls: ['./quote-summary.component.scss']
})
export class QuoteSummaryComponent implements OnInit {
  constructor(public service: DashboardService, public dialogRef: MatDialogRef<QuoteSummaryComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

      if(data){
        this.confirmedQuote=data.confirmedQuote;

        console.log('summary',data)

        if(data['quote'] && data.quote['confirmedRenewal'])
        this.confirmedRenewal=data.quote.confirmedRenewal;

        if(data['quote'] && data.quote['isPolicy'])
        this.isPolicy=data.quote.isPolicy;

        this.selectedQuote=[
          {value: data.quote['DATE_UPDATED'],label:'Date Prepared'}
        ];

        if(data.quote.PREPARED_BY)
        this.selectedQuote=[...this.selectedQuote,{value: data.quote['PREPARED_BY'],label:'Prepared By'}]

        this.selectedQuote=[
            ...this.selectedQuote,
          {value:data.quote.POLICY_SEQUENCE,label:'Policy Sequence'},
          {value: `${data.quote.CUSTOMER_FIRST_NAME} ${data.quote.CUSTOMER_LAST_NAME}`,label:'Customer Name'},
         // {value: data.quote.CUSTOMER_EMAIL,label:'Customer Email'},
          {value: data.quote.CUSTOMER_PHONE,label:'Mobile Number'},
          {value: data.quote.INCEPTION_DATE,label:'Inception Date'},
          {value: data.quote.EXPIRY_DATE,label:'Expiry Date'},
          {value: data.quote.CLIENT_CODE,label:'Client Code'},
          {value: data.quote.AGENT_CODE,label:'Agent Code'},
          {value: data.quote.YEAR_OF_MANUFACTURE,label:'Year of Manufacturing'},
          {value: `${data.quote.MAKE} ${data.quote.QUOTE_MODEL}`,label:'Make & Model'},
        //  {value: data.quote.CUBIC_CAPACITY,label:'Cubic Capacity'},
          {value: `${data.quote.CURRENCY_CODE} ${data.quote.SUM_INSURED}`,label:'Sum Insured'},
          {value: `${data.quote.QUOTE_DAYS} ${data.quote.duration_type=='shortrate'?'Month(s)':'Day(s)'}`,label:'Duration'},
          {value:(data.quote.EXCESS_TYPE_CODE=='ENA'?'NO':'YES'),label:'Excess Bought'},
          {value:`${data.quote.CURRENCY_CODE} ${!data.quote.TPPD_LIMIT?0:data.quote.TPPD_LIMIT.trim()}`,label:'Extra TPPD Bought'},
          {value:data.quote.PRODUCT_DESCRIPTION,label:'Insurance Product'}
        ];

        this.total_premium=`${data.quote.CURRENCY_CODE} ${data.quote.COST_OF_INSURANCE}`;
      }
    }

    confirmedQuote: boolean=false
    confirmedRenewal: boolean=false
    selectedQuote: QuoteElement[];
    total_premium:string;
    isPolicy:boolean=false
    displayedColumns: string[] = ['label', 'value'];

    query={
      filter:"",
      selectValue:"",
      filteredResults:[]
    }

  ngOnInit() {
    this.query.filter="";
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: {confirmedQuote:true} });
  }
  editPolicy(){
    this.dialogRef.close({ event: 'close', data: {confirmedQuote:true,edit:true} });
  }
}
